import React from 'react'

import ReactMarkdown from 'react-markdown'
import MarkdownHelper from '../utils/MarkdownHelper'

import Logo from './Logo'
import ArrowIcon from './../../assets/icons/icon-arrow.svg';

class ContentBox extends React.Component {
    constructor(props) {
        super(props);

        this.markdownProps = this.props.disableSuperscripts ? {
            ...MarkdownHelper.allTypesWithoutSuperscript(),
        } : MarkdownHelper.allTypes()

        this.state = {
            source: ''
        }
    }

    componentDidMount() {
        if(!this.props.isArrow && this.props.children) {
            const concatenateChildren = Array.prototype.concat(this.props.children)
            .filter(text => text && text.indexOf('null') === -1 && text.indexOf('undefined') === -1 && text.length !== 0);
            if(concatenateChildren.length > 2) {
                const refinedData = concatenateChildren.with(0,`__${this.props.children[0].split('__')[1]}:__ `);
                const data = refinedData.join('');
                this.setState({source: data});
            }
            else if(concatenateChildren.length){
                this.setState({source: concatenateChildren.join('')});
            }
        } 
        else if(!this.props.children) {
            this.setState({source: ''});
        }
        else {
            const concatenateChildren = Array.prototype.concat(this.props.children[0],this.props.children[1])
            .filter(text => text !== null && text.indexOf('null') === -1)
            .join('');
            this.setState({source: concatenateChildren});
        }
    }

    componentDidUpdate(prevProps) {
        const concatenateChildren = Array.prototype.concat(this.props.children)
            .filter(text => text !== null && text.indexOf('null') === -1)
            .join('')
        if (this.props.text !== prevProps.text) {
            this.setState({source: concatenateChildren});
        }
    }
    isNotNull (text, param) {
        return (text!== null && text.indexOf('null') === -1 ? param ?  param + ' ' + text : text : '')
    }


    render(){
        return (
            <div className="content-box">
                {this.props.logo && (
                    <React.Fragment>
                        <Logo logo={this.props.logo} format={this.props.campaign.partner_logo_svg_format}/>
                        <div className="seperator"></div>
                    </React.Fragment>
                )}
                {this.props.isArrow ? (
                    <div className="text js-mam-symbol-content">
                        <ReactMarkdown {...this.markdownProps} source={this.isNotNull(this.props.children[0])} />
                        {this.isNotNull(this.props.children[0]) ? 
                        (<ReactMarkdown {...this.markdownProps} source={this.isNotNull(this.props.children[1],":")} />) : 
                        (<ReactMarkdown {...this.markdownProps} source={this.isNotNull(this.props.children[1])} />)}
                        {this.isNotNull(this.props.children[2]) !== '' ? (<div className="js-mam-symbol-content-arrow">
                            <ReactMarkdown {...this.markdownProps} source={this.props.children[2]} />
                            <div className="icn arrow-position">
                                <img src={ArrowIcon} alt="Arrow" className="arrow-icon-banner-earn" />
                            </div>
                        </div>) : null }
                    </div>
                ) :
                    (<div className="text js-mam-symbol-content">
                    <ReactMarkdown {...this.markdownProps} source={this.state.source} />
                </div>) 
                }
            </div>
        )
    }

}

export default ContentBox



// WEBPACK FOOTER //
// ./src/components/subcomponents/ContentBox.js